interface ApiEnvelope<T> {
  status?: number;
  code?: number;
  message?: string;
  data?: T;
}

function resolveSuccess(payload: ApiEnvelope<unknown>): boolean {
  if (typeof payload.status === 'number') return payload.status === 0;
  if (typeof payload.code === 'number') return payload.code === 0;
  return true;
}

async function requestKimo<T>(url: string, method: 'GET' | 'POST'): Promise<T> {
  const response = await fetch(url, { method });
  if (!response.ok) {
    throw new Error(`Kimo API ${method} ${url} failed: ${response.status}`);
  }

  const payload = (await response.json()) as ApiEnvelope<T>;
  if (!resolveSuccess(payload)) {
    throw new Error(payload.message || 'Kimo API request failed');
  }
  return payload.data as T;
}

export function getKimoInstallCountApi(): Promise<number> {
  return requestKimo<number>('/kimo/api/install/count', 'GET');
}

export function getKimoInstallCheckApi(): Promise<boolean> {
  return requestKimo<boolean>('/kimo/api/install/check', 'GET');
}

export function postKimoInstallApi(): Promise<boolean> {
  return requestKimo<boolean>('/kimo/api/install', 'POST');
}
